var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.clearTextLabelWidths,
          expression: "clearTextLabelWidths"
        }
      ]
    },
    [
      _vm._l(_vm.entries, function(entry) {
        return [
          entry.type === "checkbox"
            ? _c("CheckBox", { attrs: { entry: entry } })
            : entry.type === "textInput"
            ? _c("TextInput", {
                attrs: { entry: entry, labelMinWidth: _vm.textLabelMinWidth },
                on: {
                  labelResized: function($event) {
                    return _vm.updateTextLabelWidth(entry, $event.width)
                  }
                }
              })
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }